import runValidations from 'utils/validations';

const INPUTS = {
  onChange: (name, field, value) => ({ [name]: { ...field, value } }),
  onValidate: (field, value) => runValidations({ ...field, value }),
};

export default INPUTS;
